export default "__VITE_ASSET__ca564945__"